import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "../i18n";

const AuthLanguageDropdown = ({ inverse = false }) => {
  const { language: selectedLanguage, setLanguage, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const languages = [
    {
      code: "en",
      name: t("language.native.english"),
      country: t("language.unitedKingdom"),
      flag: "/assets/uk-flag.svg",
    },
    {
      code: "pt-PT",
      name: t("language.native.portuguese"),
      country: t("language.portugal"),
      flag: "/assets/portugal-flag.svg",
    },
    {
      code: "fr",
      name: t("language.native.french"),
      country: t("language.france"),
      flag: "/assets/france-flag.png",
    },
  ];
  const currentLanguage =
    languages.find((item) => item.code === selectedLanguage) || languages[0];

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (!dropdownRef.current?.contains(event.target)) setOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setOpen(false);
    };

    document.addEventListener("pointerdown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  const selectLanguage = (code) => {
    setLanguage(code);
    setOpen(false);
  };

  return (
    <div
      className={`auth-language-switcher${inverse ? " inverse" : ""}`}
      ref={dropdownRef}
    >
      <button
        type="button"
        className="auth-language-trigger"
        aria-label={t("ui.select.language")}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((visible) => !visible)}
      >
        <img className="auth-language-flag" src={currentLanguage.flag} alt="" />
        <span className="auth-language-current-name">
          {currentLanguage.name}
        </span>
        <svg viewBox="0 0 16 16" aria-hidden="true">
          <path d="m4 6 4 4 4-4" />
        </svg>
      </button>

      {open && (
        <div className="auth-language-menu" role="menu">
          {languages.map((item) => (
            <button
              type="button"
              key={item.code}
              className={`auth-language-option${
                selectedLanguage === item.code ? " active" : ""
              }`}
              role="menuitemradio"
              aria-checked={selectedLanguage === item.code}
              onClick={() => selectLanguage(item.code)}
            >
              <img className="auth-language-option-flag" src={item.flag} alt="" />
              <span className="auth-language-option-content">
                <strong>{item.name}</strong>
                <small>{item.country}</small>
              </span>
              {selectedLanguage === item.code && (
                <span className="auth-language-check" aria-hidden="true">
                  {"\u2713"}
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AuthLanguageDropdown;